import { useEffect, useState, MouseEvent } from 'react';
import { PersonalSchedule } from '#types/schedule';
import * as S from './styles';
import { getSlotLength } from './utils';

interface Props extends PersonalSchedule {
  onClick?: (e: MouseEvent) => void;
}

export default function PersonalScheduleSlot({
  title,
  startAt,
  endAt,
  onClick
}: Props) {
  const [length, setLength] = useState<number>();

  useEffect(() => {
    setLength(getSlotLength(startAt, endAt));
  }, []);

  if (!length) {
    return null;
  }

  return (
    <S.Container onClick={onClick} title={title}>
      <S.Contents length={length}>
        <S.Title>{title.length > 3 ? title.slice(0, 3) : title}</S.Title>
      </S.Contents>
    </S.Container>
  );
}
